(function() {
  'use strict';

  function initCollectionModal() {
    const modal = document.getElementById('Collection-Modal');
    if (!modal) return;

    const backdrop = document.getElementById('Collection-Modal-Backdrop');
    const closeBtn = document.getElementById('Collection-Modal-Close');
    const grid = document.getElementById('Collection-Modal-Grid');
    const loader = document.getElementById('Collection-Modal-Loader');
    const emptyMsg = document.getElementById('Collection-Modal-Empty');
    const titleEl = document.getElementById('Collection-Modal-Title');
    const collectionLink = document.getElementById('Collection-Modal-Collection-Link');
    const footer = document.getElementById('Collection-Modal-Footer');

    function closeModal() {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function openCartDrawer() {
      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart-drawer:open');
        }
      }
    }

    if (backdrop) backdrop.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (collectionLink) {
      collectionLink.addEventListener('click', function(e) {
        const href = collectionLink.getAttribute('href');
        if (!href || href === '#' || href === 'javascript:void(0);') {
          e.preventDefault();
        } else {
          closeModal();
        }
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    });

    // Auto-close modal & open Cart Drawer when an item is added from inside the popup
    document.addEventListener('cart:item-added', function() {
      if (modal && modal.classList.contains('is-active')) {
        setTimeout(function() {
          closeModal();
          openCartDrawer();
        }, 800);
      }
    });

    function repositionMobileSizes() {
      if (!grid) return;
      const isMobile = window.innerWidth <= 767;
      grid.querySelectorAll('product-card').forEach(function(card) {
        const sizesContainer = card.querySelector('.product-card-sizes--container');
        const cardInfo = card.querySelector('.product-card-info');
        const figure = card.querySelector('.product-card--featured-image');
        if (!sizesContainer) return;
        if (isMobile && cardInfo && sizesContainer.parentElement !== cardInfo) {
          cardInfo.appendChild(sizesContainer);
        } else if (!isMobile && figure && sizesContainer.parentElement !== figure) {
          figure.appendChild(sizesContainer);
        }
      });
    }

    window.addEventListener('resize', repositionMobileSizes);

    function initProductCards() {
      repositionMobileSizes();

      grid.querySelectorAll('product-card').forEach(function(card) {
        if (!card.size_options) {
          card.size_options = card.querySelector('.product-card-sizes');
        }
        if (card.size_options && typeof card.enableSizeOptions === 'function') {
          card.enableSizeOptions();
        }
      });

      if (typeof safeAddButton === 'function') {
        safeAddButton();
      }
    }

    // Initial check if preloaded
    if (grid && (grid.dataset.preloaded === 'true' || grid.querySelectorAll('.product-card').length > 0)) {
      initProductCards();
    }

    window.openCollectionModal = function(url, collectionTitle) {
      let targetUrl = url;
      if (!targetUrl || targetUrl === '#' || targetUrl === 'javascript:void(0);') {
        targetUrl = '/collections/all';
      }

      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      if (titleEl && titleEl.dataset.custom !== 'true' && collectionTitle) {
        let cleanTitle = collectionTitle.replace(/→|\u2192/g, '').trim();
        if (cleanTitle) {
          titleEl.textContent = cleanTitle;
        }
      }

      // Update redirect collection link href if present
      if (collectionLink && targetUrl && targetUrl !== '#' && targetUrl !== 'javascript:void(0);') {
        const currentHref = collectionLink.getAttribute('href');
        if (!currentHref || currentHref === '#' || currentHref === '') {
          collectionLink.setAttribute('href', targetUrl);
        }
        if (footer) {
          footer.style.display = 'flex';
        }
      }

      // Check if products are already pre-rendered by Liquid
      const isPreloaded = grid && (grid.dataset.preloaded === 'true' || grid.querySelectorAll('.product-card').length > 0);

      if (isPreloaded) {
        if (loader) loader.style.display = 'none';
        if (emptyMsg) emptyMsg.style.display = 'none';

        initProductCards();
        return;
      }

      // If not preloaded, fetch collection URL via AJAX fallback
      grid.innerHTML = '';
      if (emptyMsg) emptyMsg.style.display = 'none';
      if (loader) loader.style.display = 'flex';

      fetch(targetUrl)
        .then(function(res) {
          if (!res.ok) throw new Error('Collection page fetch failed');
          return res.text();
        })
        .then(function(html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const productGrid = doc.querySelector('#product-grid') || doc.querySelector('.products');

          if (loader) loader.style.display = 'none';

          if (productGrid && productGrid.querySelectorAll('.product-card').length > 0) {
            productGrid.querySelectorAll('.promotion-column, .pagination, .facets-bar').forEach(function(el) {
              el.remove();
            });

            grid.innerHTML = productGrid.outerHTML;
            initProductCards();
          } else {
            if (emptyMsg) emptyMsg.style.display = 'block';
          }
        })
        .catch(function(err) {
          console.error('Error fetching collection page HTML:', err);
          if (loader) loader.style.display = 'none';
          if (emptyMsg) emptyMsg.style.display = 'block';
        });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionModal);
  } else {
    initCollectionModal();
  }

  document.addEventListener('click', function(e) {
    const banner = e.target.closest('.cart-drawer-banner');
    if (banner) {
      e.preventDefault();
      e.stopPropagation();
      const url = banner.dataset.collectionUrl || banner.getAttribute('href');
      const titleText = banner.querySelector('.cart-drawer-banner--text')?.textContent?.trim();
      if (window.openCollectionModal) {
        window.openCollectionModal(url, titleText);
      }
    }
  });
})();
